import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { ApplicationState } from "../../../store";
import * as services from "../../../store/service";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";

import WhatYouNeedToKnow from "../../common/WhatYouNeedToKnow";
import { DialogComponent } from "../../common/DialogComponent";
import { Notification } from "../../common/Notification";

import LegalDocumentContainer from "../../LegalDocumentPages/LegalDocumentContainer";
import ProtectionPlanBillingInfo from "../../Dialogs/protectionPlan/ProtectionPlanBillingInfo";
import ProtectionPlanTermsAndCondition from "../../Dialogs/protectionPlan/ProtectionPlanTermsAndCondition";
import EFTDialog from "../../Dialogs/EFTDialog";

interface IProps {
    dialogId: string;
    selectedProduct: any;
    closeDialog: any;
    closePurchaseAndOpenCompletionDialog: any;
    changeTabCallback: any;
}

const PurchaseCreditReportDialog: React.FunctionComponent<IProps> = (props) => {
    const { selectedProduct } = props;
    const salesTax = "0.00"; // This is temporary till salesTax implemented for Purchase Credit Report

    const { getTermsOfUseURL, getPrivacyNoticeURL } = LegalDocumentContainer();
    const hasSontiqBrand = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasSontiqBrand
            ? state.configurationState.configuration.partnerConfig.hasSontiqBrand === "true"
                ? true
                : false
            : false
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));

    const [showBillingInfoDialog, setShowBillingInfoDialog] = useState(false);
    let billingInfoChanged = false;

    const [tncDialog, setTncDialog] = useState(false);
    const [EFTdialog, setEFTDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState<any>({ EFTData: [], isEFTChecked: false });

    const [loadingPaymentInfo, setLoadingPaymentInfo] = useState(false);
    const [paymentMethodDetails, setPaymentMethodDetails] = useState<any>();
    const [paymentInfoState, setPaymentInfoState] = useState({
        name: "",
        cardOrAccNumber: "",
        exp: "",
        paymentMethod: "",
        address: {
            addressline1: "",
            addressline2: "",
            city: "",
            state: "",
            zipCode: "",
        },
    });

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-lg");

        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    useEffect(() => {
        services.getEFTInfo().then((data: any) => {
            setState({ ...state, EFTData: data });
        });

        getPaymentDetailsData();
    }, []);

    useEffect(() => {
        saveOrUpdatePaymentMethodDetails(paymentMethodDetails);
    }, [paymentMethodDetails]);

    const saveOrUpdatePaymentMethodDetails = (paymentMethodDetails: any) => {
        if (paymentMethodDetails && paymentMethodDetails.billingAddress !== null) {
            const billing = paymentMethodDetails.billingAddress;
            if (paymentMethodDetails.creditCard != null && paymentMethodDetails.creditCard.cardNumber != null) {
                setPaymentInfoState({
                    ...paymentInfoState,
                    cardOrAccNumber: paymentMethodDetails.creditCard.cardNumber,
                    name: paymentMethodDetails.creditCard.nameOnCard,
                    exp: paymentMethodDetails.creditCard.expDateMo + "/" + paymentMethodDetails.creditCard.expDateYr,
                    paymentMethod: paymentMethodDetails.paymentMethod?.selection,
                    address: {
                        addressline1: billing.address1,
                        addressline2: billing.address2,
                        city: billing.city,
                        state: billing.state.selection,
                        zipCode: billing.zipCode,
                    },
                });
            } else if (paymentMethodDetails.eft != null && paymentMethodDetails.eft.accountNumber != null) {
                setPaymentInfoState({
                    ...paymentInfoState,
                    cardOrAccNumber: paymentMethodDetails.eft.accountNumber,
                    name: paymentMethodDetails.eft.nameOnAccount,
                    exp: "",
                    paymentMethod: paymentMethodDetails.paymentMethod?.selection,
                    address: {
                        addressline1: billing.address1,
                        addressline2: billing.address2,
                        city: billing.city,
                        state: billing.state?.selection,
                        zipCode: billing.zipCode,
                    },
                });
            }
        }
    };

    const getPaymentDetailsData = () => {
        setLoadingPaymentInfo(true);
        services.GetPaymentDetail().then((data) => {
            setLoadingPaymentInfo(false);
            setPaymentMethodDetails({ ...paymentMethodDetails, data });

            saveOrUpdatePaymentMethodDetails(data);
        });
    };

    const showBillingInformation = (event: any) => {
        handleBillingDialog("show");
    };

    const setBillingInfoChanged = (value: boolean) => {
        billingInfoChanged = value;
    };

    const handleBillingDialog = (value: string): any => {
        if (value === "show") {
            setShowBillingInfoDialog(true);
        } else if (value === "cancel") {
            setShowBillingInfoDialog(false);
        } else if (value === "close") {
            if (billingInfoChanged) {
                getPaymentDetailsData();
                setBillingInfoChanged(false);
                setShowBillingInfoDialog(false);
            } else {
                setShowBillingInfoDialog(false);
            }
        }
    };

    const checked = () => {
        if (state.isEFTChecked) {
            setState({ ...state, isEFTChecked: false });
            return;
        }
        setState({ ...state, isEFTChecked: true });
    };

    const handleTncDialog = (value: string): any => {
        if (value === "show") {
            setTncDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setTncDialog(false);
        }
    };

    const handleCloseEFTDialog = (): any => {
        setEFTDialog(false);
    };

    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
    });

    const getTodaysNetCharge = () => {
        return selectedProduct && selectedProduct.Price ? <>${Number(Number(selectedProduct.Price) + Number(salesTax)).toFixed(2)}</> : <></>;
    };

    const getSubscriptionType = () => {
        return "ONETIME";
    };

    const onSubmit = (data: any) => {
        setLoading(true);
        services
            .PurchaseCreditReport("" + selectedProduct?.ServiceCode)
            .then((data) => {
                setLoading(false);
                if (data["isSuccess"] === true) {
                    setTimeout(() => {
                        props.closePurchaseAndOpenCompletionDialog();
                    }, 1);
                } else {
                    Notification({
                        type: "error",
                        title: "Error",
                        message: "Something went wrong, Please try again.",
                    });
                }
            })
            .catch((error) => {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: "Something went wrong, Please try again.",
                });
            });
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="cube" />
                </div>
                <h1>Purchase Credit Report</h1>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} id="purchase-credit-report-form-container">
                <div className={loading ? "loading dialog-body" : "dialog-body"}>
                    <div className="form-row">
                        <h3 className="content-sub-title">Your Cart Summary</h3>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row data-grid has-lines row-height-sm">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label font-weight-bold" id="label-selected-plan">
                                        <strong>Credit Report</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value font-weight-bold" aria-labelledby="label-selected-plan">
                                        {selectedProduct && selectedProduct.ServiceName ? selectedProduct.ServiceName : null}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    {paymentMethodDetails && paymentInfoState && (
                        <div className="form-row data-grid has-lines row-height-sm">
                            <fieldset className="form-row inline">
                                <div className="row data-row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label font-weight-bold" id="label-payment-info">
                                            <p>
                                                <strong>Payment Information</strong>
                                            </p>
                                        </div>
                                    </div>

                                    <div className={"col-xs-12 col-sm-8 col-no-gutter " + (loadingPaymentInfo ? "loading" : "")}>
                                        <div className="data-value" aria-labelledby="label-payment-info">
                                            <div className="row between-xs">
                                                <div className="col-xs col-no-gutter flex-grow-null">
                                                    {paymentInfoState.cardOrAccNumber ? (
                                                        <p>
                                                            {paymentInfoState.name && (
                                                                <span>
                                                                    {paymentInfoState.name}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            {paymentInfoState.address.addressline1 && (
                                                                <span>
                                                                    {paymentInfoState.address.addressline1}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            {paymentInfoState.address.addressline2 && (
                                                                <span>
                                                                    {paymentInfoState.address.addressline2}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            <span>
                                                                {[
                                                                    paymentInfoState.address.city,
                                                                    paymentInfoState.address.state,
                                                                    paymentInfoState.address.zipCode,
                                                                ].join(", ")}
                                                                <br />
                                                            </span>
                                                            {paymentInfoState.cardOrAccNumber && (
                                                                <span>
                                                                    {paymentInfoState.cardOrAccNumber}
                                                                    <br />
                                                                </span>
                                                            )}
                                                            {paymentInfoState.exp && (
                                                                <span>
                                                                    <em
                                                                        className={
                                                                            "las " +
                                                                            (paymentInfoState.paymentMethod === "CC" ? "la-credit-card " : "la-university ") +
                                                                            "inline-icon"
                                                                        }
                                                                    ></em>{" "}
                                                                    {paymentInfoState.exp}
                                                                    <br />
                                                                </span>
                                                            )}
                                                        </p>
                                                    ) : (
                                                        <div className="msg-generic msg-small">
                                                            <RenderIcons iconName="info-circle" />
                                                            There is no Payment Profile associated with your account.
                                                        </div>
                                                    )}
                                                    <label className="form-text-label" htmlFor="paymentMethod">
                                                        <input
                                                            type="checkbox"
                                                            style={{ display: "none" }}
                                                            id="paymentMethod"
                                                            name="paymentMethod"
                                                            ref={register({ required: true })}
                                                            checked={paymentInfoState.cardOrAccNumber ? true : false}
                                                        />
                                                        {!paymentInfoState.cardOrAccNumber &&
                                                            errors["paymentMethod"] &&
                                                            errors["paymentMethod"].type === "required" && (
                                                                <span className="form-error">You must add payment method.</span>
                                                            )}
                                                    </label>
                                                </div>

                                                <div className="col-xs col-no-gutter flex-grow-null align-center">
                                                    <span
                                                        className="default_link"
                                                        role="button"
                                                        tabIndex={0}
                                                        onKeyDown={(e) => {
                                                            showBillingInformation(e);
                                                            window.addToDataLayer({ event: "Purchase Credit Report - Billing Info" });
                                                        }}
                                                        onClick={(e) => {
                                                            showBillingInformation(e);
                                                            window.addToDataLayer({ event: "Purchase Credit Report - Billing Info" });
                                                        }}
                                                    >
                                                        <a href="/#" className="default_link" onClick={(e) => e.preventDefault()}>
                                                            {paymentInfoState.cardOrAccNumber ? "Change" : "Add"}
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    )}

                    <div className="form-row">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-plan-cost">
                                        <strong>Cost</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-plan-cost">
                                        {selectedProduct.Price && "$" + selectedProduct.Price}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className="form-row">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-plan-cost">
                                        <strong>Sales Tax</strong>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-plan-cost">
                                        ${Number(salesTax).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div className="line-divider margin-vertical-xs"></div>

                    <div className="form-row">
                        <fieldset className="form-row inline">
                            <div className="row data-row">
                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-today-charge">
                                        <h4 className="status-good">Today's Net Charge</h4>
                                    </div>
                                </div>

                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="data-value" aria-labelledby="label-today-charge">
                                        <div className="row between-xs">
                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                <h4 className="status-good">{getTodaysNetCharge()}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div className="margin-bottom-sm"></div>
                    <WhatYouNeedToKnow serviceList={[selectedProduct.ServiceCode]} selectedCountry={accountInfo?.country} />

                    <div className="msg-generic">
                        <div className="form-row data-grid">
                            <div className="form-input">
                                <label className="form-checkbox-label" htmlFor="isAgreed">
                                    <input type="checkbox" id="isAgreed" name="isAgreed" ref={register({ required: true })} />
                                    <span className="form-checkbox-label-text">
                                        By checking this box, I agree to be bound by the
                                        <span className="default_link">
                                            &nbsp;
                                            {hasSontiqBrand ? (
                                                <a className="default_link" href="https://www.sontiq.com/terms-of-use/" target="_blank" rel="noopener noreferrer">
                                                    Terms of Use
                                                </a>
                                            ) : (
                                                <a
                                                    className="default_link"
                                                    href={getTermsOfUseURL()}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Purchase Credit Report - Show TNC" });
                                                    }}
                                                >
                                                    Terms of Use
                                                </a>
                                            )}{" "}
                                            {"and "}{" "}
                                            <a className="default_link" href={getPrivacyNoticeURL()} target="_blank" rel="noopener noreferrer">
                                                Privacy Notice
                                            </a>
                                            {"."}
                                        </span>
                                    </span>
                                    {errors["isAgreed"] && errors["isAgreed"].type === "required" && (
                                        <span className="form-error">You must agree to the terms and conditions.</span>
                                    )}
                                </label>
                            </div>
                        </div>

                        {paymentInfoState.paymentMethod === "EFT" && (
                            <div className="form-row data-grid">
                                <div className="form-input">
                                    <label className="form-checkbox-label" htmlFor="isEFTChecked">
                                        <input
                                            type="checkbox"
                                            id="isEFTChecked"
                                            name="isEFTChecked"
                                            ref={register({ required: true })}
                                            onChange={() => checked()}
                                        />
                                        <span className="form-checkbox-label-text">
                                            {"I"}
                                            <span
                                                className="default_link"
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={() => {
                                                    setEFTDialog(true);
                                                    window.addToDataLayer({ event: "Purchase Credit Report - EFT Acknowledge" });
                                                }}
                                                onClick={() => {
                                                    setEFTDialog(true);
                                                    window.addToDataLayer({ event: "Purchase Credit Report - EFT Acknowledge" });
                                                }}
                                            >
                                                &nbsp;
                                                <a href="/#" className="default_link" onClick={(e) => e.preventDefault()}>
                                                    {"authorize the use"}
                                                </a>
                                                &nbsp;
                                            </span>
                                            {"of my bank account information"}
                                        </span>

                                        {errors["isEFTChecked"] && errors["isEFTChecked"].type === "required" && (
                                            <span className="form-error">You must authorize the use of your bank account information to continue.</span>
                                        )}
                                    </label>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="dialog-footer">
                    <div className="row between-xs">
                        <div className="col-xs col-no-gutter flex-grow-null"></div>
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                type="submit"
                                className="btn-default btn-primary"
                                id="btn-submit-purchase"
                                disabled={false}
                                onClick={() => window.addToDataLayer({ event: "Credit Report Purchase - Submit" })}
                            >
                                <span className="btn-text">Purchase</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            {showBillingInfoDialog && (
                <DialogComponent
                    dialogId="purchase-credit-report-billing-information-dialog"
                    title="BillingInformation"
                    datalayerEvent="Purchase Credit Report - Close billing info"
                    closeDialog={() => {
                        handleBillingDialog("close");
                    }}
                >
                    <ProtectionPlanBillingInfo
                        dialogId="purchase-credit-report-billing-information-dialog"
                        setBillingInfoChanged={setBillingInfoChanged}
                        getSubscriptionType={getSubscriptionType}
                        selectedPackage={selectedProduct}
                        closeDialog={() => {
                            handleBillingDialog("close");
                        }}
                    />
                </DialogComponent>
            )}

            {tncDialog && (
                <DialogComponent
                    dialogId="purchase-credit-report-termsAndCondition-dialog"
                    title="TermsNConditions"
                    datalayerEvent="Purchase Credit Report - Close TNC"
                    closeDialog={() => handleTncDialog("close")}
                >
                    <ProtectionPlanTermsAndCondition dialogId="purchase-credit-report-termsAndCondition-dialog" closeDialog={() => handleTncDialog("close")} />
                </DialogComponent>
            )}

            {EFTdialog && (
                <DialogComponent dialogId="whatsIncluded" hideCloseButton={true} title="Your Cart" closeDialog={handleCloseEFTDialog}>
                    <EFTDialog data={state.EFTData} closeDialog={handleCloseEFTDialog}></EFTDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default PurchaseCreditReportDialog;
